import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/empty-table-history-success-booking.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6c2d7974")

_pushScopeId("data-v-6c2d7974")
const _hoisted_1 = { class: "flex-grow flex flex-col min-h-0 relative font-montserrat" }
const _hoisted_2 = { class: "flex items-center justify-between gap-x-4 text-black-lp-300 mb-3" }
const _hoisted_3 = { class: "text-base font-semibold" }
const _hoisted_4 = { class: "flex items-center gap-x-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text-base font-semibold" }, " Reset ", -1)
const _hoisted_7 = { class: "relative w-max m-0 overflow-auto h-full table-modal-area" }
const _hoisted_8 = { class: "w-max m-0 table-fixed border-separate" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col gap-y-6 items-center justify-center w-full"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "empty history success booking"
}, null, -1)
const _hoisted_14 = { class: "font-bold text-black-lp-300 text-sm" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "bg-white flex items-center justify-between py-3 gap-4 border-t border-gray-lp-400" }
const _hoisted_17 = { class: "flex items-center gap-x-2 px-2" }
const _hoisted_18 = { for: "all" }
const _hoisted_19 = { class: "flex items-center gap-x-3" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "text-right leading-4 text-xs text-black-lp-300" }
const _hoisted_22 = { class: "flex items-center gap-x-1.5 font-semibold text-black-lp-100" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "rounded-full w-1 h-1 bg-gray-lp-600" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("printReceipt.booking.successHistory")) + " (" + _toDisplayString(_ctx.data.length) + ") ", 1),
      _createVNode("div", _hoisted_4, [
        (_ctx.lastBooking)
          ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("printReceipt.booking.lastBooking")) + " " + _toDisplayString(_ctx.lastBooking), 1))
          : _createCommentVNode("", true),
        _createVNode("button", {
          class: ["flex items-center gap-x-2", _ctx.data.length ? 'text-red-lp-100' : 'text-gray-lp-600'],
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args))),
          disabled: !_ctx.data.length
        }, [
          _createVNode(_component_Icons, {
            name: "reload",
            class: "w-5 cursor-pointer"
          }),
          _hoisted_6
        ], 10, ["disabled"])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("table", _hoisted_8, [
        _createVNode("thead", null, [
          _createVNode("tr", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, index) => {
              return (_openBlock(), _createBlock("th", {
                key: `head-${col.name}-${index}`,
                class: col.class,
                style: { ...col.style }
              }, [
                (col.slotHeaderName)
                  ? _renderSlot(_ctx.$slots, `header:${col.slotHeaderName}`, {
                      key: 0,
                      data: col,
                      index: index
                    }, undefined, true)
                  : (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(col.name), 1))
              ], 6))
            }), 128))
          ])
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock("tbody", _hoisted_10, [
              (!_ctx.data.length)
                ? (_openBlock(), _createBlock("tr", _hoisted_11, [
                    _createVNode("td", {
                      colspan: _ctx.column.length
                    }, [
                      (_ctx.errorType)
                        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                            key: 0,
                            errorType: _ctx.errorType,
                            onTryAgain: _ctx.request,
                            customClass: "py-8"
                          }, null, 8, ["errorType", "onTryAgain"]))
                        : (_openBlock(), _createBlock("div", _hoisted_12, [
                            _hoisted_13,
                            _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("printReceipt.booking.emptyList")), 1)
                          ]))
                    ], 8, ["colspan"])
                  ]))
                : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.data, (item, i) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: `row-${i}`
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, idx) => {
                        return (_openBlock(), _createBlock("td", {
                          key: `col-${col.name}-${idx}`,
                          class: ["col", col.class],
                          style: { ...col.style }
                        }, [
                          (col.isCheckbox)
                            ? (_openBlock(), _createBlock(_component_Checkbox, {
                                key: 0,
                                id: i,
                                name: 'checkbox' + i,
                                modelValue: item.selected,
                                "onUpdate:modelValue": ($event: any) => (item.selected = $event),
                                binary: ""
                              }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue"]))
                            : (col.slotName)
                              ? _renderSlot(_ctx.$slots, `body:${col.slotName}`, {
                                  key: 1,
                                  data: item,
                                  index: i
                                }, undefined, true)
                              : _createCommentVNode("", true),
                          (col.render)
                            ? (_openBlock(), _createBlock("div", {
                                key: 2,
                                innerHTML: col.render(item, i)
                              }, null, 8, ["innerHTML"]))
                            : _createCommentVNode("", true)
                        ], 6))
                      }), 128))
                    ]))
                  }), 128))
            ]))
          : (_openBlock(), _createBlock("tbody", _hoisted_15, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from({ length: 10 }), (_item, i) => {
                return (_openBlock(), _createBlock("tr", {
                  key: `row-${i}`
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, idx) => {
                    return (_openBlock(), _createBlock("td", {
                      key: `col-${col.name}-${idx}`,
                      class: ["col", col.class],
                      style: { ...col.style }
                    }, [
                      _createVNode(_component_Skeleton)
                    ], 6))
                  }), 128))
                ]))
              }), 128))
            ]))
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_Checkbox, {
          id: "all",
          name: "all",
          modelValue: _ctx.isAll,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => (_ctx.isAll = $event)),
            _ctx.onCheckAll
          ],
          binary: "",
          disabled: !_ctx.data.length
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
        _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("printReceipt.booking.selectAll")), 1)
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("printReceipt.booking.selected")), 1),
          _createVNode("div", _hoisted_22, [
            _createVNode("span", null, _toDisplayString(_ctx.selectedData.total) + " STT ", 1),
            _hoisted_23,
            _createVNode("span", null, _toDisplayString(_ctx.selectedData.amount), 1)
          ])
        ]),
        _createVNode(_component_LpButton, {
          iconV2: "",
          iconLeft: "print-summary",
          sizeIcon: "w-4",
          color: "red-lp-100",
          iconGroupHoverColor: "white",
          title: _ctx.$t('printReceipt.booking.printThermal'),
          textColor: "white",
          onClick: _ctx.printThermalBulk,
          disabled: !_ctx.selectedData.total
        }, null, 8, ["title", "onClick", "disabled"]),
        _createVNode(_component_LpButton, {
          iconV2: "",
          iconLeft: "invoice-v2",
          sizeIcon: "w-4",
          iconGroupHoverColor: "white",
          color: "red-lp-100",
          title: _ctx.$t('printReceipt.booking.createInvoice'),
          textColor: "white",
          onClick: _ctx.createInvoice,
          disabled: !_ctx.selectedData.total
        }, null, 8, ["title", "onClick", "disabled"])
      ])
    ])
  ]))
})